import { LoginPageTemplate } from './ui';
import { useScoutSignIn } from './hooks';

export const ScoutLoginPage = () => {
  const { signInLoading, onSignInWithGoogleClick, onSignInWithMicrosoftClick } = useScoutSignIn();

  return (
    <LoginPageTemplate
      title="Scout login"
      description="Discover creators in real time with Scout."
      signInLoading={signInLoading}
      onSignInWithGoogleClick={onSignInWithGoogleClick}
      onSignInWithMicrosoftClick={onSignInWithMicrosoftClick}
    />
  );
};
